import React from "react";
import Helmet from "../../../components/common/Helmet";
import PolicyTemplate from "../components/PolicyTemplate";
import pageContent from "../content/termsOfService";

import pageInfo from "../../config/scripts/pageInfo";

const TermsOfService = (props) => {
  const hero = {
    title: "Terms of Service"
  };

  const cta = {
    mainText: "Need More Information?",
    smallText:
      "Contact Us For Any of Your Co-Manufacturing, Co-Packing or Wholesale Brittle Needs!",
    buttonSrc: pageInfo.contact.link,
    buttonCopy: pageInfo.contact.navTitle + " Us",
  };

  return (
    <>
      <Helmet
        metaTitle={pageInfo.termsOfService.meta.title}
        metaDesc={pageInfo.termsOfService.meta.description}
      />
      <PolicyTemplate
        heroTitle={hero.title}
        // Content
        content={pageContent}
        // CTA
        ctaMainText={cta.mainText}
        ctaSmallText={cta.smallText}
        ctaButtonSrc={cta.buttonSrc}
        ctaButtonCopy={cta.buttonCopy}
      ></PolicyTemplate>
    </>
  );
};

export default TermsOfService;
